import { useAdminApp } from "@/hooks/useAdminApp";
import { useStateMachineValue } from "@/core/arch/state_machine";
import { Button } from "@/components/ui/base/button";
import { Input } from "@/components/ui/base/input";
import { Label } from "@/components/ui/base/label";

export function ContactStep() {
  const { provisioningBloc } = useAdminApp();
  const [state] = useStateMachineValue(provisioningBloc);
  const { formData, fieldErrors } = state;

  return (
    <div>
      <h2 className="border-border text-foreground mb-6 border-b pb-4 text-lg font-semibold">
        Contact Information
      </h2>
      <div className="grid grid-cols-2 gap-5">
        <div>
          <Label htmlFor="firstName">First Name</Label>
          <Input
            id="firstName"
            value={formData.firstName ?? ""}
            onChange={(e) =>
              provisioningBloc.updateField("firstName", e.target.value)
            }
          />
          {fieldErrors.firstName && (
            <p className="mt-1 text-xs text-red-600">{fieldErrors.firstName}</p>
          )}
        </div>
        <div>
          <Label htmlFor="lastName">Last Name</Label>
          <Input
            id="lastName"
            value={formData.lastName ?? ""}
            onChange={(e) =>
              provisioningBloc.updateField("lastName", e.target.value)
            }
          />
          {fieldErrors.lastName && (
            <p className="mt-1 text-xs text-red-600">{fieldErrors.lastName}</p>
          )}
        </div>
        <div>
          <Label htmlFor="email">Email</Label>
          <Input
            id="email"
            type="email"
            value={formData.email ?? ""}
            onChange={(e) =>
              provisioningBloc.updateField("email", e.target.value)
            }
          />
          {fieldErrors.email && (
            <p className="mt-1 text-xs text-red-600">{fieldErrors.email}</p>
          )}
        </div>
        <div>
          <Label htmlFor="phone">Phone</Label>
          <Input
            id="phone"
            type="tel"
            placeholder="+1 (555) 000-0000"
            value={formData.phone ?? ""}
            onChange={(e) =>
              provisioningBloc.updateField("phone", e.target.value)
            }
          />
          <p className="text-muted-foreground mt-1 text-xs">
            Include country code (e.g. +1 for US/CA, +61 for AU)
          </p>
          {fieldErrors.phone && (
            <p className="mt-1 text-xs text-red-600">{fieldErrors.phone}</p>
          )}
        </div>
      </div>
      <div className="border-border mt-8 flex justify-end border-t pt-6">
        <Button onClick={() => provisioningBloc.nextStep()}>Next →</Button>
      </div>
    </div>
  );
}
